import { IconJourneyItem } from '@components/icons/journey-icon';
import { useScopedTranslate } from '@locale/translate';

import { useFlowNodes } from 'ui/journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'add_to_journey';

export const Node = (node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  useFlowNodes();

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        node={node}
        icon={<IconJourneyItem color="teal100" />}
        label={t('title')}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Add traveller to journey',
  },
};
